import * as React from 'react';
import * as Constants from 'src/constants';
import * as Layout from 'src/components/Layout';
import Link from 'next/link';
import Text from 'src/components/Text';
import TextInput from 'src/components/TextInput';
import CreateButton from './CreateButton';
import { useRouter } from 'next/router';
import { Image, StyleSheet, View } from 'react-native';

const LoginScreen: React.FC<{}> = () => {
  const [phone, setPhone] = React.useState<string>('');
  const router = useRouter();
  const redirectUrl = Array.isArray(router.query.redirect) ? router.query.redirect[0] : router.query.redirect;

  const logoImageSource = React.useMemo(() => {
    return {
      uri: '/static/images/app/logo-login.png?v=1',
      width: Constants.Grid.dp(176),
      height: Constants.Grid.dp(36),
    };
  }, []);

  const onChangePhoneText = React.useCallback((text: string) => {
    setPhone(text.replace(/[^0-9]/g, ''));
  }, []);

  return (
    <View style={styles.root}>
      <Layout.EdgeGutter style={styles.card}>
        <View style={Constants.GridStyle.MB2Unit}>
          <Image
            source={logoImageSource}
            width={Constants.Grid.dp(175)}
            height={Constants.Grid.dp(36)}
            style={styles.logoImage}
            resizeMode='contain'
          />
        </View>
        <View style={Constants.GridStyle.MB2Unit}>
          <Text style={Constants.TextStyle.T16B}>{'Create your free OneShop account'}</Text>
          <Text style={[Constants.TextStyle.T12R, Constants.TextStyle.CDarkGray, Constants.GridStyle.MBUnit]}>
            {'Register and get a text message to the app. Get set up in less than 3 minutes.'}
          </Text>
          <Text style={[Constants.TextStyle.T12R, Constants.TextStyle.CDarkGray, Constants.GridStyle.MB2Unit]}>
            {'OneShop has a 7 day free trial that starts after you get set up.'}
          </Text>
          <Text style={[Constants.TextStyle.T12M, Constants.GridStyle.MBUnit]}>{'Mobile phone number'}</Text>
          <TextInput
            autoFocus
            autoComplete='tel'
            style={Constants.TextStyle.T16R}
            keyboardType='number-pad'
            textContentType='telephoneNumber'
            value={phone}
            onChangeText={onChangePhoneText}
            maxLength={16}
          />
        </View>
        <CreateButton phone={phone} redirectUrl={redirectUrl} />
        <Text
          style={[
            Constants.TextStyle.T10R,
            Constants.TextStyle.CDarkGray,
            Constants.GridStyle.MB2Unit,
            Constants.GridStyle.MT4Unit,
          ]}
        >
          {'By continuing, you agree to OneShop’s'}{' '}
          <Link href='/legal/terms'>
            <a target='_blank'>
              <Text style={[Constants.TextStyle.T10M, Constants.TextStyle.CDarkGray]}>{'Terms of Service'}</Text>
            </a>
          </Link>
          {', '}
          <Link href='/legal/privacy'>
            <a target='_blank'>
              <Text style={[Constants.TextStyle.T10M, Constants.TextStyle.CDarkGray]}>{'Privacy Policy'}</Text>
            </a>
          </Link>
          {', and '}
          <Link href='/legal/electronic-communications'>
            <a target='_blank'>
              <Text style={[Constants.TextStyle.T10M, Constants.TextStyle.CDarkGray]}>
                {'Electronic Communications Disclosure'}
              </Text>
            </a>
          </Link>
          {'.'}
        </Text>
      </Layout.EdgeGutter>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    width: Constants.Grid.dp(360),
    maxWidth: '100%',
  },
  logoImage: {
    width: Constants.Grid.dp(175),
    height: Constants.Grid.dp(36),
  },
  cardModal: {
    width: Constants.Grid.dp(480),
  },
});

export default LoginScreen;
